import axios from 'axios';
import retry from 'async-retry';
import * as keys from './keys';
import utils from '../utils';

/**
 * @object            movie
 * @property {string} id
 * @property {string} title
 * @property {string} poster_path
 * @property {string} release_date
 * @property {string} genre_ids
 * @property {string} vote_average
 * @property {string} vote_count
 * @property {string} popularity
 * @property {string} importance
 * @property {string} similarity
 * @property {string} imdb_id
 */

export default {
  async getSearchedMovie(query, movies) {
    const url = `https://api.themoviedb.org/3/search/movie?api_key=${keys.MOVIES_DB_KEY}&language=en-US&page=1&include_adult=false&query=${query}`;

    try {
      return await retry(async bail => {
        const response = await axios.get(url);
        movies(response.data.results.filter(result => result.vote_count > 50));
      }, {
        retries: 5
      });
    } catch (error) {
      console.log(error);
    }
  },
  async getRecommendations(movie, movies) {
    const url = `https://api.themoviedb.org/3/movie/${movie.id}/recommendations?api_key=${keys.MOVIES_DB_KEY}&language=en-US&page=1`;

    try {
      return await retry(async bail => {
        const response = await axios.get(url);
        let results = response.data.results.filter(result => result.vote_count > 50)
          .map(result => utils.setImportanceIndex(result));
        results = results.map(result => utils.setSimilarityIndex(movie, result));
        movies(results);
      }, {
        retries: 5
      });
    } catch (error) {
      console.log(error);
    }
  },
  async getGenres(genres) {
    const url = `https://api.themoviedb.org/3/genre/movie/list?api_key=${keys.MOVIES_DB_KEY}&language=en-US`;

    try {
      return await retry(async bail => {
        const response = await axios.get(url);
        genres(response.data.genres);
      }, {
        retries: 5
      });
    } catch (error) {
      console.log(error);
    }
  },
  async getImdbId(movie) {
    const url = `https://api.themoviedb.org/3/movie/${movie.id}?api_key=${keys.MOVIES_DB_KEY}&language=en-US`;

    try {
      return await retry(async bail => {
        const response = await axios.get(url);
        return response.data.imdb_id;
      }, {
        retries: 5
      });
    } catch (error) {
      console.log(error);
      return null;
    }
  },
};
